import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { InfoYellow } from '@dhl/icons'
import type { ReturnType } from '~/model'

type Props = {
  returnType: ReturnType
}

const returnTypeToDetailInfoMapping: Record<ReturnType, string> = {
  pickup: 'pickupDetailInfo',
  consumer_pickup: 'consumerPickupDetailInfo',
  service_point: 'servicePointDetailInfo',
}

export const ReturnTypeDetailInfoItem = ({ returnType }: Props) => {
  const { t } = useTranslation()

  return (
    <Typography
      sx={({ typography: { fontSize } }) => ({
        fontSize,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
      })}
      data-test={`return-type-detail-info-${returnType}`}
    >
      <InfoYellow sx={{ marginRight: 1 }} />
      {t(returnTypeToDetailInfoMapping[returnType])}
    </Typography>
  )
}
